import React from "react";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
//import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

import {yesNo} from "enums"
import styles from "assets/jss/material-dashboard-pro-react/views/form";

import {
  ibSave,
  //ibsFetch,
  ibFetch
} from 'actions/ibs'

import {
  danger,
} from 'actions/notification'

class IbQuestionnaire extends React.Component {
	state = {
		form: {
			clientPreviousTradingExperience: '',
      expectedBusinessType: '',
      supplyTradingStatement: '',
      otherCounterparty: '',
      activeClientsNumber: '',
      retailInstitutionalClientsPercentage: '',
      partnerAsset: '',
      targetMarketAndClientDirectCompetitor: '',
      expectedMonthlyVolume: '',
      expectedAverageDeposit: ''
    },
  }

    componentDidMount() {
        if(this.props.match.params.id) {
            this.props.saveWizardData(this.props.stepDataObject.data)
            this.setState({
                ...this.state,
                form: {
                    clientPreviousTradingExperience: this.props.stepDataObject.data.clientPreviousTradingExperience,
                    expectedBusinessType: this.props.stepDataObject.data.expectedBusinessType,
                    supplyTradingStatement: this.props.stepDataObject.data.supplyTradingStatement,
                    otherCounterparty: this.props.stepDataObject.data.otherCounterparty,
                    activeClientsNumber: this.props.stepDataObject.data.activeClientsNumber,
                    retailInstitutionalClientsPercentage: this.props.stepDataObject.data.retailInstitutionalClientsPercentage,
                    partnerAsset: this.props.stepDataObject.data.partnerAsset,
                    targetMarketAndClientDirectCompetitor: this.props.stepDataObject.data.targetMarketAndClientDirectCompetitor,
                    expectedMonthlyVolume: this.props.stepDataObject.data.expectedMonthlyVolume,
                    expectedAverageDeposit: this.props.stepDataObject.data.expectedAverageDeposit
                }
            })
        }
    }

	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: "")}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}
	submit(e){
    e.preventDefault()
    let data = {...this.props.wizardData, ...this.state.form}

    this.props.save(data)
      .then(e => {
        this.props.saveWizardData(e)
        this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
	}
  render() {
		const {classes} = this.props
  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
				
					<GridItem xs={12} sm={11} md={11}>

						{this.getInput({
							key:'clientPreviousTradingExperience',
							name:'What previous trading experience do the clients have?',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'expectedBusinessType',
							name:'What type of business will we expect to see from yourself or your clients?',
							icon:'',
							type:'text',
							required:false
						})}

						<FormControl
							fullWidth
							className={classes.selectFormControl}
							style={{marginTop:'10px', marginBottom: '17px'}}
						>

							<InputLabel
								htmlFor="nationality"
								className={classes.selectLabel}
							>
								Can you supply trading statements?
							</InputLabel>

							<Select
								required={false}
								native
								value={this.state.form.supplyTradingStatement || '' }
								MenuProps={{ className: classes.selectMenu }}
								classes={{ select: classes.select }}            
								inputProps={{
									onChange: event => this.change(event, "supplyTradingStatement"),
									id: "supplyTradingStatement"
								}}
							>
								<option value="" disabled></option>
								{Object.values(yesNo).map(item => 
									<option key={item.label} value={item.value}>{item.label}</option>
								)}
							</Select>  
						</FormControl>

						{this.getInput({
							key:'otherCounterparty',
							name:'Other counterparties currently trading with',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'activeClientsNumber',
							name:'Total Number of Active Clients',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'retailInstitutionalClientsPercentage',
							name:'Percentage (%) of active clients that are retail or Institutional Clients',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'partnerAsset',
							name:'Assets under management from partner',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'targetMarketAndClientDirectCompetitor',
							name:'Target Market and Direct competitors to client',
							icon:'',
							type:'text',
							required:false
						})}

						
						{this.getInput({
							key:'expectedMonthlyVolume',
							name:'Expected monthly volumes',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'expectedAverageDeposit',
							name:'Average Deposits expected',
							icon:'',
							type:'text',
							required:false
						})}


					</GridItem>

					<GridItem sm={11}>
						<div style={{float: 'left'}}>
							<Button
								// color="success"
								type="button"
								onClick={(e) => this.props.goToPreviousStep()}
								style={{position:'absolute', bottom:'10px', left:'40px'}}
							>
								Previous
							</Button>
						</div>
						<div style={{float: 'right'}}>
							<Button
								color="success"
								type="submit"
								style={{position:'absolute', bottom:'10px', right:'40px'}}
							>
								Next
							</Button>
						</div>
					</GridItem>
				</GridContainer>
			</form>
  	);
  }
}
const state=(state)=>({
  ibs: state
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
})
export default withStyles(styles)(connect(state,dispatch)(IbQuestionnaire))



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/IbQuestionnaire.jsx